import {Vue} from '~/addiesaas'
import GotmehookdApp from './gotmehookd-app'
import NotFoundLayout from './not-found-layout'
import BlankLayout from './blank-layout'
import GuestLayout from './guest-layout'
import DocumentLayout from './document-layout'
import MainLayout from './main-layout'
import MainLayoutTopRight from './main-layout-top-right'
import FormGroupLayout from './form-group-layout'
import ScrollableLayout from './scrollable-layout'
import PostCreateLayout from './post-create-layout'
import SimpleModalLayout from './simple-modal-layout'
import ControlModalLayout from './control-modal-layout'
import TitleModalLayout from './title-modal-layout'
import LeftPanelLayout from './left-panel-layout'

const requires = {
    GotmehookdApp,
    NotFoundLayout,
    BlankLayout,
    GuestLayout,
    DocumentLayout,
    MainLayout,
    MainLayoutTopRight,
    FormGroupLayout,
    ScrollableLayout,
    PostCreateLayout,
    SimpleModalLayout,
    ControlModalLayout,
    TitleModalLayout,
    LeftPanelLayout,
}

Object.values(requires).forEach(component => {
    Vue.component(component.name, component)
})

export default requires
